@if (vm.currentQuestion) {
  <h2
    class="heading-4 mb-12 md-mb-16"
    [innerHTML]="vm.currentQuestion.questionLabel"
    [class.qa-spacing]="questionHelp"
  ></h2>
  @if (questionHelp) {
    <div class="body mb-12 md-mb-12 question-help" [innerHTML]="questionHelp"></div>
  }

  @if (vm.currentQuestion?.questionLabel?.toLowerCase().includes('can our engineer access your boiler safely')) {
    <p class="body">
      <span class="bold"> If your boiler is in a loft, </span>
      there must be safe access to reach it.
    </p>

    <p class="body mt-12 mb-16">
      <span class="bold"> If your boiler is in a cupboard, </span>
      the boiler cover must be removable whilst it's inside the cupboard. Our engineers can't remove cupboards or fitted
      units.
    </p>
  }

  @switch (vm.currentQuestion.answerType) {
    @case ('RADIO_BUTTONS') {
      <section class="radio-buttons flex gap-12" [class.flex-col]="vm.currentQuestion.answerData.length > 2">
        @for (option of vm.currentQuestion.answerData; track option.answerID; let index = $index) {
          <app-radio-button
            variant="blue"
            [ngModel]="vm.formValue?.[vm.currentQuestion.questionID]"
            (ngModelChange)="answerChangedToggle()"
            [includeResetOption]="false"
            [name]="vm.currentQuestion.questionID"
            [index]="index"
            [optionValue]="option"
            [attr.data-TestId]="'qa-option-' + option.answerLabel"
          >
            <p class="body radio-text">{{ option.answerLabel }}</p>
          </app-radio-button>
        }
      </section>
    }
    @case ('DATE') {
      <app-calendar-picker
        [ngModel]="vm.formValue?.[vm.currentQuestion.answerData[0].answerID]"
        [name]="vm.currentQuestion.answerData[0].answerID"
        [showTodaySelection]="true"
        [onlyShowActiveDatesInCurrentMonth]="true"
        [showShortenedDays]="true"
        [maxDate]="todaysDate"
        [allowEmptyDates]="true"
      ></app-calendar-picker>
    }
    @case ('LIST') {
      <app-select-list
        [ngModel]="vm.formValue?.[vm.currentQuestion.questionID]"
        [name]="vm.currentQuestion.questionID"
        valueKey="answerLabel"
        [options]="vm.listFields"
        (ngModelChange)="answerChangedToggle()"
      />
    }

    @case ('RESPONSE_FIELD') {
      <app-text-area
        [ngModel]="vm.formValue?.[vm.currentQuestion.answerData[0].answerID]"
        [name]="vm.currentQuestion.questionID"
        [dataLabel]="vm.currentQuestion.questionLabel"
        [placeHolder]="placeholderTextBreakdown"
        dataTestId="response-textarea"
      ></app-text-area>
    }
  }
  @let selectedValue = vm.formValue?.[vm.currentQuestion.questionID];
  @if (selectedValue && showSubQuestionSection(selectedValue) && showSubQuestion()[vm.currentQuestion.questionID]) {
    <section class="sub-question" data-testid="sub-question-list">
      @let values = vm.formValue?.[vm.currentQuestion.questionID].answerValues;
      @if (selectedValue.answerHint) {
        <p class="body bold mb-8">
          {{ selectedValue.answerHint }}
        </p>
      }

      @if (selectedValue.answerType === 'DROPDOWN') {
        <section class="flex-col gap-8">
          @for (option of values; track option; let index = $index) {
            <app-radio-button
              variant="blue"
              [ngModel]="vm.formValue?.[vm.currentQuestion.questionID + '_subAnswer']"
              [includeResetOption]="false"
              [name]="vm.currentQuestion.questionID + '_subAnswer'"
              [index]="index"
              [optionValue]="option"
              data-testid="sub-question"
            >
              <p class="body radio-text">{{ option }}</p>
            </app-radio-button>
          }
        </section>
      }

      @if (selectedValue.answerType === 'RESPONSE_FIELD' || effectiveSubQuestion) {
        @if (effectiveSubQuestion?.label) {
          <p class="body mb-8" [class.bold]="!selectedValue?.answerHint">{{ effectiveSubQuestion?.label }}</p>
        }
        <app-text-area
          [ngModel]="vm.formValue?.[vm.currentQuestion.questionID + '_subAnswer']"
          [name]="vm.currentQuestion.questionID + '_subAnswer'"
          [dataLabel]="effectiveSubQuestion?.label"
          [minlength]="selectedValue.answerMinimumCharacters"
          [maxCharCount]="effectiveSubQuestion?.maxLength ?? selectedValue.answerMaximumCharacters ?? 250"
          dataTestId="sub-answer-textarea"
          [hasError]="!!vm.errors?.[vm.currentQuestion.questionID + '_subAnswer'] && vm.formSubmitted"
          [placeHolder]="secondaryQuestionPlaceHolderText ?? ''"
        ></app-text-area>
      }

      @if (vm.errors?.[vm.currentQuestion.questionID + '_subAnswer'] && vm.formSubmitted) {
        <section class="error mt-16">
          <i class="fa-light fa-circle-exclamation"></i>
          <p class="body" data-testid="sub-answer-error">{{ subAnswerValidationType }}</p>
        </section>
      }
    </section>
  }

  @if (blockingAnswerMessage) {
    @if (blockingAnswerMessage === 'WATER_SUPPLY') {
      <ol class="ordered-list mt-16 flex flex-col gap-8">
        <li class="body bold">
          <p class="body">
            <span class="bold">Find your stopcock.</span> It's usually under the kitchen sink or near your water meter.
          </p>
        </li>
        <li class="body bold">
          <p class="body"><span class="bold">Turn off your water supply </span> using the stopcock.</p>
        </li>
        <li class="body bold">
          <p class="body">
            <span class="bold">Turn on a cold tap </span> to help drain any remaining water from the pipes.
          </p>
        </li>
      </ol>
    } @else {
      <section class="blocking-message mt-16" data-testid="blocking-answer-message">
        <p class="body" [innerHTML]="blockingAnswerMessage"></p>
      </section>
    }
  }
  @if (
    (vm.errors?.[vm.currentQuestion.questionID] || vm.errors?.[vm.currentQuestion.answerData[0].answerID]) &&
    vm.formSubmitted
  ) {
    <section class="error mt-16">
      <i class="fa-light fa-circle-exclamation"></i>
      <p class="body" data-testid="empty-date-error">{{ validationType }}</p>
    </section>
  }
}
<div class="divider mt-24 mb-24 sm-mt-16 sm-mb-16"></div>
